#include <beginnormal_vertex>

#include "angle_matrix_definition.glsl"

objectNormal.xz = rotationMatrix * objectNormal.xz;